import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import { StyleClass } from '../Styles/CSS';
import { Fonts } from '../Styles/SharedStyles';
import * as styles from './DisplayTooltipsContainer.css';

export function DisplayTooltipsContainer() {
	return (
		<ReactTooltip
			class={`${styles.tooltipFrame} ${StyleClass(`tooltipStyleClass`, defaultTooltipStyle)}`}
			delayHide={1000}
		/>
	);
}

export const defaultTooltipStyle = {
	...Fonts.shareTechMono,
	color: `#e4d3ad !important`,
	fontSize: `12px !important`,
	letterSpacing: `0.08em !important`,
	textShadow: `0 0 5px rgba(207, 163, 91, 0.32) !important`,
	textTransform: `uppercase !important`,
	zIndex: '9999 !important' as any // Required to make tooltips show for sweetalert modals
};
